export default __webpack_public_path__ + "static/media/yabe_hover.898f8c17.png";